export function formatHrefLink(message: string): string {
  const hyperLinkRegex = /\bhttps?:\/\/[^\s<>"'`]+[^\s<>"'`.,!?;:)\]\}]/g;
  const subst = `<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>`;

  return message.replace(hyperLinkRegex, subst);
}
